import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useController } from '../hooks/useController'
import { useControllerActions } from '../hooks/useControllerActions'
import { useTexts } from '../useTexts'

export function Footer() {
  const texts = useTexts()
  const {
    data: { requestInProgress, initialValidationInProgress },
  } = useController()
  const actions = useControllerActions()
  const { status, invalid } = useController()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          disabled={invalid || initialValidationInProgress || status !== 'ready'}
          testid="modal-primary-button"
          onClick={actions.duplicateOrder}
          loading={requestInProgress}
          variant="contained"
        >
          {texts.duplicateButtonTitle}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton
          testid="modal-secondary-button"
          onClick={actions.cancelAndCloseTryCloseTransaction}
        >
          {texts.cancelButtonTitle}
        </ModalFooterButton>
      }
    />
  )
}
